import navLogo from '../photos/misc/fwcas logo.jpg';

export const Header = () => {
    return (
        <div id="brand-header">
            <img style={{minHeight: "3em", maxHeight: "3em"}} src={navLogo} alt={"fwcas logo"} />
        </div>
    )
}